module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAArUlEQVQokZWSvQ3CMBCFP1upGICSDZjBdVYIPRJslAHYACYIJTMgQZEBECWSKfIsHIgPOOlkv/d8P7qzC6GODOZ0JnwFFrxspHsR7u3BN4zPKvxllaEdgbkV6ArayqroDa0B1lZgzLwTvwF2QCu+Ed+RTRXgLO+Fb8Aj0+6698K4EOpSNxeGPU7NIFpT3QKzklip56msByOpOdU9cLIqlva4ZPxXPyqmVST7BfMEqoomQ3pXr24AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/14c.png
// module id = IvXo
// module chunks = 65